import React from 'react';
import { BaasicInput } from 'core/components';
import { observer } from 'mobx-react-lite';
import ReactTooltip from 'react-tooltip';
import { BaasicDropdown } from 'core/components';

const AddressAutofill = observer(
	({
		viewStore: {
			parentViewData,
			debouncedAutofillSearch,
			onAddressInputFocusChange,
			handleKeyDown,
			form,
			addressAutofillDropdownStore,
			onAutofillDropdownFocusChange
		},
		t,
	}) => {
		return (
			<React.Fragment>
				<div className="pos--rel">
					<div className="spc--bottom--sml">
						<ReactTooltip />
						<BaasicInput
							className="spc--bottom--sml fs-mask"
							field={parentViewData.address1}
							value={parentViewData.address1.value}
							placeholder={t('ADDRESSAUTOFILL.PLACEHOLDER')}
							onInput={e => debouncedAutofillSearch(e.target.value)}
							onPaste={e => debouncedAutofillSearch(e.clipboardData.getData('text'))}
							onFocus={() => onAddressInputFocusChange(true)}
							onBlur={() => onAddressInputFocusChange(false)}
							autoComplete="off"
							labelTooltip="ADDRESSAUTOFILL.TOOLTIP"
							onKeyDown={handleKeyDown}
						/>
					</div>
					<div hidden={form.$('displayDropdown').value ? '' : 'hidden'} className="dropdown--in-input">
						{form.$('displayDropdown').value && (
							<div className="dropdown--in-input">
								<BaasicDropdown
									dropdownStore={addressAutofillDropdownStore}
									menuIsOpen={true}
									onFocus={() => onAutofillDropdownFocusChange(true)}
								/>
							</div>
						)}
					</div>
				</div>
			</React.Fragment>
		);
	}
);

export default AddressAutofill;



// WEBPACK FOOTER //
// ./src/core/components/select/AddressAutofill.jsx